import React from 'react';
import styled from 'styled-components';

const Logo = ({ width = 400, height = 120 }) => {
  return (
    <LogoSVG width={width} height={height} viewBox="0 0 200 60" xmlns="http://www.w3.org/2000/svg">
      {/* Anvil shape */}
      <path d="M40 10 L60 10 L65 25 L55 50 L45 50 L35 25 Z" fill="#333" stroke="#C41E3A" strokeWidth="2" />
      
      {/* Hammer */}
      <path d="M70 15 L85 10 L90 15 L85 30 L75 35 L65 30 Z" fill="#C41E3A" stroke="#333" strokeWidth="1" />
      <rect x="65" y="30" width="5" height="20" fill="#8B4513" stroke="#333" strokeWidth="1" />
      
      {/* Gold coin */}
      <circle cx="30" cy="30" r="15" fill="#DAA520" stroke="#8B4513" strokeWidth="2" />
      <circle cx="30" cy="30" r="12" fill="#F5DEB3" stroke="#DAA520" strokeWidth="1" />
      <text x="25" y="35" fontFamily="Arial" fontSize="12" fontWeight="bold" fill="#8B4513">$</text>
      
      {/* Sparks */}
      <path d="M50 15 L53 10 L56 15 L53 20 Z" fill="#E25822" />
      <path d="M60 20 L63 15 L66 20 L63 25 Z" fill="#E25822" />
      <path d="M45 20 L48 15 L51 20 L48 25 Z" fill="#E25822" />
      
      {/* Text */}
      <LogoText x="100" y="30" fontFamily="Arial" fontSize="18" fontWeight="bold" fill="#333">Master</LogoText>
      <LogoText x="100" y="48" fontFamily="Arial" fontSize="18" fontWeight="bold" fill="#C41E3A">Collectors Forge</LogoText>
    </LogoSVG>
  );
};

const LogoSVG = styled.svg`
  display: block;
`;

const LogoText = styled.text`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }
`;

export default Logo;
